import { API_ROUTE_ADMIN_FEATURE_LIST } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export type FeatureOriginal = {
  id: number
  name: string
  description: string
  active: number
  activationUrl: string | null
  deactivationUrl: string | null
  customerFeatures: {
    id: number
    customerId: number
    statusId: number | null | undefined
    logs: {
      id: number
      action: string
      timestamp: string
    }[]
  }[]
  salesPitch?: {
    id: number
    countryId: number
    title: string
    description: string
    salesPitch: string
  }
}

export const getFeatureList = async () => {
  const features = await get<FeatureOriginal[]>(API_ROUTE_ADMIN_FEATURE_LIST, IS_NEW_BACKEND_API)
  const filteredFeatures = features.filter(feature => feature.salesPitch)
  return filteredFeatures
}
